import { render } from "./CustomerHorses.vue?vue&type=template&id=409b1546"
import script from "./CustomerHorses.vue?vue&type=script&lang=js"
export * from "./CustomerHorses.vue?vue&type=script&lang=js"

import exportComponent from "/Users/iomac/Progetti/equiup/equiupmaneggi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__